import * as Role from "../Entities/Role";
import * as Status from "../Entities/RoleStatus";

const STORY_LOCKED_REVIEW_STATUSES = [
  Status.PRINTING,
  Status.SHIPPING,
  Status.APPROVED,
];

const IN_PROGRESS_REVIEW_STATUSES = [
  Status.WAITING_APPROVAL,
  Status.REVIEWE,
  Status.PRINTING,
  Status.SHIPPING,
];

export const isDraftBook = (book) => Number(book?.Status) === Status.DRAFT;

export const isRejectedBook = (book) =>
  Number(book?.ReviewStatus) === Status.REJECTED;

export const isInactiveBook = (book) => Number(book?.Status) === Status.INACTIVE;

export const canCreateBook = (roleId) => Number(roleId) === Role.USER;

export const canEditStoryBook = (roleId, book = {}) => {
  if (book.IsArchived || isInactiveBook(book)) {
    return false;
  }
  if (STORY_LOCKED_REVIEW_STATUSES.includes(Number(book.ReviewStatus))) {
    return false;
  }
  const draft = isDraftBook(book);
  switch (Number(roleId)) {
    case Role.USER:
      return draft || isRejectedBook(book);
    case Role.REVIEWER:
      return !draft && !isRejectedBook(book);
    case Role.ADMIN:
      return !draft;
    default:
      return false;
  }
};

export const canChangeReviewStatus = (roleId, book = {}) => {
  if (book.IsArchived || isDraftBook(book) || isInactiveBook(book)) {
    return false;
  }
  const reviewStatus = Number(book.ReviewStatus);
  switch (Number(roleId)) {
    case Role.ADMIN:
      return (
        reviewStatus === Status.WAITING_APPROVAL ||
        reviewStatus === Status.REVIEWE
      );
    case Role.REVIEWER:
      return reviewStatus === Status.WAITING_APPROVAL;
    default:
      return false;
  }
};

export const canArchiveBook = (roleId, book = {}) => {
  if (Number(roleId) !== Role.ADMIN || book.IsArchived) {
    return false;
  }
  if (isDraftBook(book) || isInactiveBook(book)) {
    return true;
  }
  const reviewStatus = Number(book.ReviewStatus);
  if (IN_PROGRESS_REVIEW_STATUSES.includes(reviewStatus)) {
    return false;
  }
  return (
    reviewStatus === Status.REJECTED || reviewStatus === Status.APPROVED
  );
};
